import { render, staticRenderFns } from "./ButtonActivate.vue?vue&type=template&id=5023a051&scoped=true&"
import script from "./ButtonActivate.vue?vue&type=script&lang=js&"
export * from "./ButtonActivate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonActivate.vue?vue&type=style&index=0&id=5023a051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023a051",
  null
  
)

export default component.exports